import { render, staticRenderFns } from "./TitleBlock.vue?vue&type=template&id=318c8d58&scoped=true&"
import script from "./TitleBlock.vue?vue&type=script&lang=js&"
export * from "./TitleBlock.vue?vue&type=script&lang=js&"
import style0 from "./TitleBlock.vue?vue&type=style&index=0&id=318c8d58&lang=scss&scoped=true&"
import style1 from "./TitleBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318c8d58",
  null
  
)

export default component.exports